import * as React from 'react';

import type { NotificationsClient } from '@/api/notifications-client';
import { HttpNotificationsClient } from '@/api/notifications-client.http';

// =============================================================================
// notifications-client-context.tsx — Injection du NotificationsClient (DI seam, R15-COM-06).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par DÉFAUT : l'adaptateur HTTP RÉEL — la route réelle
// n'a donc AUCUN provider à câbler (parité supplier-history / reminders / relance-journal). Les tests de
// composant injectent le StubNotificationsClient via ce provider (enveloppe locale).

const defaultNotificationsClient: NotificationsClient =
  new HttpNotificationsClient();

const NotificationsClientContext = React.createContext<NotificationsClient>(
  defaultNotificationsClient,
);

export interface NotificationsClientProviderProps {
  client?: NotificationsClient | undefined;
  children: React.ReactNode;
}

export function NotificationsClientProvider({
  client = defaultNotificationsClient,
  children,
}: NotificationsClientProviderProps): React.JSX.Element {
  return (
    <NotificationsClientContext.Provider value={client}>
      {children}
    </NotificationsClientContext.Provider>
  );
}

export function useNotificationsClient(): NotificationsClient {
  return React.useContext(NotificationsClientContext);
}
